'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SwapOutButton = _react2['default'].createClass({
    displayName: 'SwapOutButton',


    propTypes: {
        initialButton: _react2['default'].PropTypes.element.isRequired,
        swapInChildren: _react2['default'].PropTypes.element.isRequired
    },

    getInitialState: function getInitialState() {
        return { isSwapped: false };
    },
    doSwap: function doSwap() {
        this.setState({ isSwapped: true });
    },
    render: function render() {
        var children;
        if (this.state.isSwapped) {
            children = this.props.swapInChildren;
        } else {
            children = _react2['default'].cloneElement(this.props.initialButton, {
                'onClick': this.doSwap
            });
        }
        return _react2['default'].createElement(
            'span',
            null,
            children
        );
    }
});
module.exports = SwapOutButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/swap-out-button.jsx
 ** module id = 710
 ** module chunks = 0
 **/